import { ResidentAppBoundary } from '@pandiafi/components'
import React from 'react'

import { DefectNoticeList } from 'components/DefectNoticeList'
import { SidebarDataLoader } from 'views/DefectNotice/DefectNoticeSidebarDataLoader'

export default function DefectNotices() {
  return (
    // Its own region, so the rest of the aside shows while the notices load
    <ResidentAppBoundary>
      <SidebarDataLoader>
        {({ defectNotices }) =>
          defectNotices.length > 0 ? (
            <DefectNoticeList defectNotices={defectNotices} />
          ) : null
        }
      </SidebarDataLoader>
    </ResidentAppBoundary>
  )
}
